module.exports = __webpack_public_path__ + "media/assets/icons/ic_outline-work-outline-cdc2e5fd673b8e68ab16e5f6dca6e307.svg";